import React from 'react'
import Head from 'next/head'
import BackgroundImage from '../../../src/components/background'
import Layout from '../../../src/components/layout';
import pageBg from '../../../public/images/credit-bg.jpg';
import styles from './teachers.module.scss';
import Popup from '../../../src/components/popup';
import ArrowButton from '../../../src/components/arrowButton';
import playClick from '../../../src/components/actions/default-click';
import playHover from '../../../src/components/actions/default-hover';
import Question from '../../../src/components/icons/question';

function index({dataAudio}) {
  const bgData = {
      bgImage: pageBg
  }
  const pageData = {
    title: 'להורים ומורים',
    content: '<p>התערוכה בנויה לביקור אישי של ילד, או קבוצה קטנה של ילדים מול מחשב אישי.</p><p>אם הצפייה היא במסגרת ביתית, אנו ממליצים לכם כהורים לחוות את התערוכה בעצמכם, לפני או יחד עם ילדכם. אם ילדכם עדיין אינו בן שתים עשרה, נוכחותכם יחד איתו חשובה עוד יותר.</p><p>אם הסיור מתקיים במסגרת כתתית, מומלץ מאד למחנכ\ת הכיתה לחוות את כל התערוכה באופן אישי לפני המסירה לתלמידים.</p>',
    popButton1: {
      text: 'סיור פרטני בתערוכה',
      type: '2',
      popup: 'popup1',
    },
    popButton2: {
      text: 'הצעה לסיור כתתי בתערוכה',
      type: '2',
      popup: 'popup2',
    },
    pageButton: {
      color: '#223A57',
      text: 'אודות הפרויקט',
    }
  }
  const popupData = {
    popup1: {
      title: 'סיור פרטני בתערוכה',
      content: "<p>התערוכה בנויה לביקור אישי של ילד או קבוצה קטנה של ילדים מול מחשב אישי.</p><p>מערכת שמע: התערוכה מלווה בקרינות, במוזיקה ובאפקטים קוליים. בכדי לחוות את סרטון הפתיחה, וכן את סיפוריהם של פודי הילדים בפרק 3, יש צורך במערכת שמע ולהפעיל את הרמקול או להעזר באזניות.</p><p>עדויות: בכל חלק בתערוכה קיימים לחצני עדויות, המסומנים באייקון של ציטוט. בלחיצה על האייקון יפתח קטע קצר של עדות מוסרטת של ילד מסתור מתוך מאגר העדויות של גנזך קידוש השם. בנוסף, מובא סיפורו המקוצר של העד, כדי לספק לצופים השלמה של הסיפור.</p><p>שאלות: גם לחצני שאלות מסומנים באייקון של סימן שאלה. השאלות והתשובות הנפתחות בלחיצה ומספקות חומר רקע היסטורי, ופרטים נוספים על עולמם של ילדי המסתור, ומאפשרים למבקרים להעמיק בנושאים המעניינים אותם.</p><p>הצפייה בעדויות ובשאלות אינה חובה, וביכולתו של המבקר להאריך או לקצר בה לפי הסבלנות ומידת העניין שלו. מומלץ מאד לאפשר לילד לחוות בעצמו את חווית העניין, החקירה והלמידה, בהתאמה לסקרנותו, יכולותיו וצרכיו. האורך המשוער של כל אחד מהפרקים הוא כעשרים דקות, כולל צפיה בכל העדויות. ניתן לעבור ולנווט בין פרק לפרק באמצעות תפריט הניווט המוצג בצד ימין של המסך.</p>",
      type: 'info',
      id: 1,
    },
    popup2: {
      title: 'הצעה לסיור כתתי בתערוכה',
      content: '<p>מומלץ מאד למורה הכיתה לחוות את כל התערוכה באופן אישי לפני המסירה לתלמידים.</p><p>ההמלצה לסיור כיתתי היא להקצות מחשב אחד לכל קבוצה של עד שלושה תלמידים. באופן הזה, הכיתה תפתח בצפייה משותפת בסרטון, ובדברי הדרכה של המורה. לאחר מכן כל קבוצה תחקור באופן עצמאי את התערוכה במשך כשעה עד שעה ורבע.</p><p>הכיתה תחזור לדיון קבוצתי על אחד או יותר מהנושאים הבאים:</p><ul><li>אהבת ההורים והמסירות המתגלה דווקא בפרידה</li><li>מקורות כח של הילדים בזמן המסתור</li><li>זהות עצמית מול סביבה זרה או עויינת</li><li>המניעים של פודי הילדים להקדשת זמן ומאמצים לפדיון ילדים זרים</li><li>תהליכים של שיקום לאחר קושי</li><li>השוואה בין תחושת הבגידה והנטישה של הילדים בזמן אמת, ובין המבט הבוגר המבין שכל הצדדים פעלו מתוך אהבה.</li><li>גבורה וביטוייה בזמן השואה</li></ul><p>ניתן גם לפצל את התערוכה לארבעה שיעורים, בכל שיעור יוקדש פרק אחד ללמידה צפייה ודיון.  (לקריאה נוספת על החלוקה של ארבעת הפרקים חיזרו לעמוד ‘אודות הפרויקט’ שם מפורט כל פרק ותוכנו)</p>',
      type: 'info',
      id: 2,
    },
  }

  // Popup Function
  const openPopup = (ID, element) => {
    //console.log(element);
    let popup = document.getElementById(ID);
    if(popup.classList.contains('active')) {
      popup.classList.remove('active');
    } else {
      popup.classList.add('active');
    }
  }


  return (
    <Layout header='show' footer='hide' audio={dataAudio}>
        <Head>
          <meta name="robots" content="noindex"></meta>
        </Head>
        <section className={`vertical-wrapper relative h-screen w-screen z-10 overflow-hidden flex flex-nowrap flex-row-reverse ${styles.container}`}>
          <BackgroundImage data={bgData} moveBG={true} />
          <div 
          className={`v-section w-screen h-auto z-50 flex content-center justify-center ${styles.wrapper}`}>
            <div className={`${styles.content}`}>
              <h1>{pageData.title}</h1>
              <div className={`${styles.text}`} dangerouslySetInnerHTML={{__html: pageData.content}}></div>
              <div className={`${styles.buttonsGroup}`}>
              <div className={`flex justify-start w-full ${styles.magnetic}`}>
                    <button 
                    onClick={() => {
                      openPopup(pageData?.popButton1?.popup, this);
                      playClick();
                    }}
                    onMouseEnter={() => {
                        playHover();
                    }}
                    className={`poplink flex items-center flex-row-reverse ${styles.buttonInfo}`}>
                        <span className={styles.iconText}>{pageData?.popButton1?.text}</span>
                        <span 
                        className={`flex items-center justify-center ${styles.icon}`}>
                          <span className={styles.after}></span>
                          <Question />
                        </span>
                    </button>
                  </div>
                  <div className={`flex justify-start w-full ${styles.magnetic}`}>
                    <button 
                    onClick={() => {
                      openPopup(pageData?.popButton2?.popup, this);
                      playClick();
                    }}
                    onMouseEnter={() => {
                        playHover();
                    }}
                    className={`poplink flex items-center flex-row-reverse ${styles.buttonInfo}`}>
                        <span className={styles.iconText}>{pageData?.popButton2?.text}</span>
                        <span 
                        className={`flex items-center justify-center ${styles.icon}`}>
                          <span className={styles.after}></span>
                          <Question />
                        </span>
                    </button>
                  </div>
              </div>
            </div>
            <div className={`absolute direction-rtl z-50 ${styles.button}`}>
                <ArrowButton 
                  onClick={() => {
                    playClick();
                  }}
                  onMouseEnter={() => {
                    playHover();
                  }}
                  className='p-5'
                  link='/about/' 
                  color={pageData?.pageButton?.color} 
                  textColor={pageData?.pageButton?.color} 
                  text={pageData?.pageButton?.text}
                 />
            </div>
          </div>
        </section>
      <Popup popupID={'popup1'} data={popupData.popup1} />
      <Popup popupID={'popup2'} data={popupData.popup2} />
    </Layout>
  )
}

export default index;